import styled from '@emotion/styled';
import { Divider, Select, Space } from 'antd';
import moment from 'moment';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { BondEntity } from '../../../../../entities/bond.entity';
import { ConnectedUserEntity } from '../../../../../entities/ConnectedUserEntity';
import { DetenteurEntity } from '../../../../../entities/detenteur.entity';
import { ParameterType } from '../../../../../redux/userStore/reducer';
import { YELLOW } from '../../../../../shared/colors';
import { formatNum } from '../../../../../shared/constants';
import { getDetenteurs } from '../../../../panel/emissionBond/network';
import { getParameter } from '../../../network';

const Container = styled.div`
  font-family: Poppins-R;

  .ant-divider-inner-text {
    font-size: 14px;
  }
  .ant-divider-horizontal.ant-divider-with-text-left::after {
    border-top: 1px solid white;
  }

  .ant-divider-horizontal.ant-divider-with-text-left::before {
    border-top: 1px solid white;
  }

  p {
    margin: 0px;
  }

  > .operation {
    display: flex;
    justify-content: center;

    > .box {
      display: flex;
      justify-content: center;
      padding: 5px;
      border-radius: 10px;
      background-color: ${YELLOW};
      width: 120px;
    }
  }
`;

export const ConfirmationOrder = ({
  bond,
  typeOpe,
  detailOpe,
  getSelectedDetenteur,
}: {
  bond: BondEntity;
  typeOpe: 'vente' | 'achat';
  detailOpe: any;
  getSelectedDetenteur: (detUrl: string) => void;
}) => {
  const connectedUser: ConnectedUserEntity = useSelector(
    (state: any) => state.userReducer,
  ).user;
  const [detenteurs, setDetenteurs] = useState<any[]>([]);
  const [parameter, setParameter] = useState<ParameterType>({
    id: '',
    com_intermediation: 0,
    com_conservation: 0,
    droit_garde: 0,
    com_courtage: 0,
    created_at: '',
  });

  useEffect(() => {
    getDetenteurs(connectedUser.id).then(({ data }) => {
      setDetenteurs(
        data.map((det: DetenteurEntity) => {
          return {
            label: `${det.code_referent} - ${det.nom} ${det.prenom || ''}`,
            value: det.url,
          };
        }),
      );
    });

    getParameter(1).then(({ data: response }) => {
      setParameter(response);
      console.log(response);
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const datejour = new Date();

  const dateMature = new Date(bond.dateMaturite);
  var duree_annee =
    (dateMature.getTime() - datejour.getTime()) / (1000 * 60 * 24 * 365);
  //recupérons les chiffres après la virgule
  var valString = duree_annee.toString();
  var nbre = valString.split('.');
  var delta = parseFloat('0.' + nbre[1]);
  const prixTaux = (detailOpe.qte * 10000 * bond.tauxMarginal) / 100;
  const valaRestant = prixTaux * delta;
  var valaPercevoir: any = valaRestant.toFixed(2);
  var valaPayer = prixTaux - valaPercevoir;
  var valaPay: any = valaPayer.toFixed(2);
  var com_intermediation = parameter.com_intermediation
    ? parameter.com_intermediation
    : 0;
  var com_conservation = parameter.com_conservation
    ? parameter.com_conservation
    : 0;
  var droit_garde = parameter.droit_garde ? parameter.droit_garde : 0;
  var com_courtage = parameter.com_courtage ? parameter.com_courtage : 0;
  var com1 =
    typeOpe === 'achat'
      ? detailOpe.prix * detailOpe.qte * com_intermediation
      : 0;
  var com2 =
    typeOpe === 'achat' ? detailOpe.prix * detailOpe.qte * com_conservation : 0;
  var com3 =
    typeOpe === 'achat' ? detailOpe.prix * detailOpe.qte * droit_garde : 0;
  var com4 =
    typeOpe === 'achat' ? detailOpe.prix * detailOpe.qte * com_courtage : 0;
  var mnt_global = 10000 * detailOpe.qte;
  var decote = 100 - detailOpe.prix / 100;
  // var MontantAPayer = Math.round(
  //   typeOpe === 'achat'
  //     ? detailOpe.prix * detailOpe.qte +
  //         detailOpe.prix * detailOpe.qte * (0.0027 + 0.002 + 0.003 + 0.002) +
  //         parseFloat(valaPay)
  //     : detailOpe.prix * detailOpe.qte + parseFloat(valaPay),
  // );

  return (
    <Container>
      <Divider orientation='left' style={{ color: 'white', marginBottom: 2 }}>
        Description de l'ordre
      </Divider>

      <div className='operation'>
        <Space className='box'>
          <p>{typeOpe === 'achat' ? 'ACHAT' : 'VENTE'} : </p>
          <p>{detailOpe.qte}</p>
        </Space>
      </div>

      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Space size={30}>
          <div>
            <p>Date Valeur : </p>
            <p>Pays : </p>
            <p>Code : </p>
            <p>Instrument : </p>
          </div>
          <div>
            <p>{moment(datejour).format('DD/MM/YYYY')}</p>
            <p>{bond.pays}</p>
            <p>{bond.code}</p>
            <p>{bond.instrument}</p>
          </div>
        </Space>

        <Space size={30}>
          <div>
            <p>Dernier coupon: </p>
            <p>Taux int. : </p>
            <p>Taux rendement : </p>
            <p>Fréq. paiement : </p>
          </div>
          <div>
            <p>{moment(bond.dateMaturite).format('DD/MM/YYYY')}</p>
            <p>{bond.tauxMarginal} %</p>
            <p>0%</p>
            <p>{bond.frequencePaiement}</p>
          </div>
        </Space>
      </div>

      <Divider orientation='left' style={{ color: 'white', marginBottom: 2 }}>
        Montant
      </Divider>

      <div
        style={{
          display: 'flex',
          justifyContent: 'space-between',
          alignItems: 'flex-start',
        }}
      >
        <Space size={30}>
          <div>
            <p>Quantité : </p>
            <p>Montant Global (A): </p>
            <p>Décôte (B):</p>
            <p>Coupon couru à payer (C):</p>
            <p>Coupon à percevoir: </p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p>{formatNum(parseInt(detailOpe.qte))}</p>
            <p>{formatNum(parseInt(mnt_global.toFixed(2)))} XAF</p>
            <p>{formatNum(parseFloat(decote.toFixed(2)))}%</p>
            <p>{formatNum(parseInt(valaPay))} XAF</p>
            <p>{formatNum(parseInt(valaPercevoir))} XAF</p>
          </div>
        </Space>
        <Space size={30}>
          <div>
            <p>Com. Intermédiation({com_intermediation * 100}% - D):</p>
            <p>Com. conservation({com_conservation * 100}% - E):</p>
            <p>Droit de garde({droit_garde * 100}% - F): </p>
            <p>Com. de courtage({com_courtage * 100}% - G):</p>
          </div>
          <div style={{ textAlign: 'right' }}>
            <p>{formatNum(parseInt(com1.toFixed(2)))} XAF</p>
            <p>{formatNum(parseInt(com2.toFixed(2)))} XAF</p>
            <p>{formatNum(parseInt(com3.toFixed(2)))} XAF</p>
            <p>{formatNum(parseInt(com4.toFixed(2)))} XAF</p>
          </div>
          <div></div>
        </Space>
      </div>

      {typeOpe === 'achat' && (
        <>
          <Divider
            orientation='left'
            style={{ color: 'white', marginBottom: 2 }}
          >
            Client
          </Divider>
          <Space>
            <p>Détenteur : </p>
            <Select
              style={{ width: '350px' }}
              options={detenteurs}
              onChange={(val) => getSelectedDetenteur(val)}
            />
          </Space>
        </>
      )}

      <Divider orientation='left' style={{ color: 'white' }}>
        Total
      </Divider>
      <div style={{ display: 'flex', justifyContent: 'space-between' }}>
        <Space size={60}>
          <div>
            {typeOpe === 'achat' && <p>Total à payer (H= A*B + C+D+E+F+G): </p>}
            {typeOpe === 'vente' && (
              <p>Total à percevoir(H= A*B + C - (D+E+F+G)) : </p>
            )}
          </div>
          <div style={{ textAlign: 'right' }}>
            {/* <p>
              {typeOpe === 'achat'
                ? formatNum((detailOpe.prix * detailOpe.qte * 0.001) / 100)
                : 0}{' '}
              XAF
            </p> */}
            <p style={{ color: 'green', fontWeight: 'bold' }}>
              {typeOpe === 'achat'
                ? formatNum(
                    Math.round(
                      detailOpe.prix * detailOpe.qte +
                        detailOpe.prix *
                          detailOpe.qte *
                          (0.0027 + 0.002 + 0.003 + 0.002) +
                        parseFloat(valaPay),
                    ),
                  )
                : formatNum(
                    Math.round(
                      detailOpe.prix * detailOpe.qte + parseFloat(valaPay),
                    ),
                  )}{' '}
              XAF
            </p>
          </div>
          <div></div>
        </Space>
      </div>
    </Container>
  );
};
